/** First `referrer` query value — matches URLSearchParams.get in PrivateSignUpRoute. */
export const parseSignupReferrer = (search: string): string | undefined => {
    return new URLSearchParams(search).get('referrer') ?? undefined;
};

export const isPartnerSignupUrl = (pathname: string, search: string): boolean => {
    return pathname.toLowerCase().startsWith('/sign-up') && Boolean(parseSignupReferrer(search));
};

export type PartnerSignupFunnelAudience = {
    pathname: string;
    search: string;
    userLoaded: boolean;
    isAuthenticated: boolean;
};

/** Unauthenticated booking referrer hits /sign-up but PrivateSignUpRoute sends them to Discover. */
export const isUnauthenticatedBookingSignupRedirect = ({
    search,
    userLoaded,
    isAuthenticated,
}: Pick<PartnerSignupFunnelAudience, 'search' | 'userLoaded' | 'isAuthenticated'>): boolean =>
    userLoaded && !isAuthenticated && parseSignupReferrer(search) === 'booking';

/** Unauthenticated visitors who will actually see the partner sign-up form. */
export const isPartnerSignupFunnelAudience = ({
    pathname,
    search,
    userLoaded,
    isAuthenticated,
}: PartnerSignupFunnelAudience): boolean => {
    if (!userLoaded || isAuthenticated) {
        return false;
    }

    if (isUnauthenticatedBookingSignupRedirect({ search, userLoaded, isAuthenticated })) {
        return false;
    }

    return isPartnerSignupUrl(pathname, search);
};

/** Booking B4B visitors hand off to Discover — never count as signup drop-off. */
export const isBookingSignupReferrer = (referrer: string | undefined): boolean => referrer === 'booking';
